import React, {useState} from "react";
import UploadFile from "./UploadFile";
import SelectContent from "./Select";
import Input from "./Input";

const App = () => {
    const [endpoint, setEndpoint] = useState(null)
    const [token, setToken] = useState('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQG1lZmkudm4iLCJmdWxsTmFtZSI6IkFkbWluaXN0cmF0b3IiLCJfaWQiOiI2NTA3ZDUxODRiYzdjMjhkYjQ2Y2EyNDUiLCJpYXQiOjE3MDA2MjE5MjQsImV4cCI6MTcwMDcwODMyNH0.gFMlJAVYKgHom9grTbnqfFf2qz6aBSsbo8Mzr0BmxVg')
    const [organization, setOrganization] = useState('651d0a5d785c77b0dac60170')
    const [template, setTemplate] = useState('651d0a5d785c77b0dac60171')
    const [data, setData] = useState([
        {
            endpoint: 'http://localhost:3000',
            title: "LOCAL"
        },
        {
            endpoint: 'https://mefi-upload.mefibay.com',
            title: "SERVER DEV"
        },
        {
            endpoint: 'https://upload-hub.mefi.vn',
            title: "SERVER PRODUCT"
        },
    ])
    const handleChange = ({ endpoint }) => {
        setEndpoint(endpoint);
    };

    const handleChangeToken = (event) => {
        setToken(event.target.value);
    }

    const handleChangeOrganization = (event) => {
        setOrganization(event.target.value);
    }

    const handleChangeTemplate = (event) => {
        setTemplate(event.target.value);
    }

    return (
        <>
            <SelectContent
                options={data}
                handleChange={handleChange}
                value={endpoint}
            />
            { endpoint && <Input handleChange={handleChangeToken} value={token} placeholder={`Token`} />}
            { endpoint && <Input handleChange={handleChangeOrganization} value={organization} placeholder={`Organization ID`} />}
            { endpoint && <Input handleChange={handleChangeTemplate} value={template} placeholder={`Template ID`} />}
            { endpoint && <UploadFile endpoint={endpoint} token={token} organization={organization} template={template} /> }
        </>
    )
}

export default App